import theme, { createStyles,ThemeColors } from 'core/utilities/theme';

export default createStyles({
  search: {
    display: 'flex',
    alignItems: 'center',
    height: '30px',
    background: 'white',
    borderRadius: '4px',
    border: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    width: '300px',
  },
  results: {
    position: 'absolute',
    top: '36px',
    padding: '8px',
    background: 'white',
    borderRadius: '4px',
    border: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    width: '300px',
    textAlign: 'left',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: theme.typography.body2.fontSize,
  },
  iconButton: {
    padding: '5px 10px',
  },
});
